import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import useIsExtraSmallScreen from '@medflex/hooks/useIsExtraSmallScreen';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import isMobileDeviceOrApp from '@medflex/utils/isMobileDeviceOrApp';

const useNavBarContext = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const toggle = () => dispatch.navBar.toggle();
  const minimize = () => dispatch.navBar.minimize();
  const shouldShowBottomCollapsedMenu = useIsExtraSmallScreen() || isMobileDeviceOrApp();
  const shouldShowFullMenu = useIsWideScreen();
  const { isMaximizedDesktop, isMaximizedMobile, status } = useSelector(state => state.navBar);

  useEffect(() => {
    if (location && status !== 'loaded') {
      if (location.pathname === '/') {
        dispatch.navBar.load({
          isMaximizedMobile: true,
        });
        return;
      }
      dispatch.navBar.load();
    }
  }, [location]);

  /* handles menu states when resizing:
  when menu is expanded and reducing screen size it should collapse */
  useEffect(() => {
    if (isMaximizedMobile && !shouldShowFullMenu) {
      minimize();
    }
  }, [shouldShowFullMenu]);

  const isCollapsed = useMemo(() => {
    const shouldCollapseMenu = shouldShowFullMenu ? !isMaximizedDesktop : !isMaximizedMobile;
    return shouldShowBottomCollapsedMenu || shouldCollapseMenu;
  }, [shouldShowFullMenu, shouldShowBottomCollapsedMenu, isMaximizedDesktop, isMaximizedMobile]);

  return { toggle, status, isCollapsed };
};

export default useNavBarContext;
